export default __webpack_public_path__ + "static/media/11.c27bd46f.jpg";